import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { useAuth } from "@/context/AuthContext";
import { Field, ProjectPicker, SpacePicker, SubmitRow } from "@/components/forms/Fields";

export const NoteForm = ({ kind, item, defaults, onDone }) => {
  const { user } = useAuth();
  const { space, run } = useApp();
  const n = item || {};
  const [f, setF] = useState({
    title: n.title || "", body: n.body || "",
    space: n.space || defaults.space || (space !== "all" ? space : user.username),
    project_id: n.project_id ?? defaults.project_id ?? null,
  });
  const [busy, setBusy] = useState(false);
  const set = (k) => (v) => setF((s) => ({ ...s, [k]: v?.target ? v.target.value : v }));
  const thought = kind === "thought";

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const ok = await run(
      () => (item ? api.patch(`/notes/${item.id}`, f) : api.post("/notes", { ...f, kind })),
      item ? "Saved" : thought ? "Thought logged" : "Note added",
    );
    setBusy(false);
    if (ok) onDone();
  };

  return (
    <form onSubmit={submit} className="space-y-5" data-testid={`${kind}-form`}>
      <Field label="Title (optional)">
        <Input value={f.title} onChange={set("title")} placeholder={thought ? "Topic" : "Quick title"} data-testid={`${kind}-title-input`} className="h-11" />
      </Field>
      <Field label={thought ? "What do we need to talk about?" : "Note"}>
        <Textarea autoFocus value={f.body} onChange={set("body")} rows={5} required placeholder={thought ? "Should we change how we handle..." : "Write anything. No emails are sent."} data-testid={`${kind}-body-input`} />
      </Field>
      <Field label="Whose space"><SpacePicker value={f.space} onChange={set("space")} /></Field>
      <Field label="Project (optional)"><ProjectPicker value={f.project_id} onChange={set("project_id")} /></Field>
      <SubmitRow busy={busy} label={item ? "Save" : thought ? "Log thought" : "Add note"} onCancel={onDone} testid={`${kind}-submit-button`} />
    </form>
  );
};
